export default "__VITE_ASSET__DPlkzwWz__"